/* eslint-disable react/prop-types */
// Argon Dashboard 2 MUI components
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonAvatar from "components/ArgonAvatar";
import ArgonBadge from "components/ArgonBadge";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";

// Images
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";
import team4 from "assets/images/team-4.jpg";

function Author({ image, name, email }) {
  return (
    <ArgonBox display="flex" alignItems="center" px={0.5} py={0.1}>
      <ArgonBox mr={2}>
        <ArgonAvatar src={image} alt={name} size="md" variant="full" />
      </ArgonBox>
      <ArgonBox display="flex" flexDirection="column">
        <ArgonTypography variant="caption" fontWeight="medium">
          {name}
        </ArgonTypography>
        <ArgonTypography variant="caption" color="secondary">
          {email}
        </ArgonTypography>
      </ArgonBox>
    </ArgonBox>
  );
}

function Function({ job, org }) {
  return (
    <ArgonBox display="flex" flexDirection="column">
      <ArgonTypography variant="caption" fontWeight="medium" color="text">
        {job}
      </ArgonTypography>
      <ArgonTypography variant="caption" color="secondary">
        {org}
      </ArgonTypography>
    </ArgonBox>
  );
}

const extractAddressPart = (address, label) => {
  if (!address) return "N/A";

  const match = address.match(new RegExp(`${label}\\s*:\\s*([^,]+)`, "i"));
  return match ? match[1].trim() : "N/A";
};

const parentsProfileTableData = (classes = []) => ({
  columns: [
    // { name: "author", align: "left" },
    // { name: "function", align: "left" },
    // { name: "status", align: "center" },
    // { name: "employed", align: "center" },
    // { name: "action", align: "center" },

    { name: "sno", align: "center" },
    { name: "Class Name", align: "left" },
    { name: "Mode", align: "left" },
    // { name: "State", align: "left" },
    // { name: "City", align: "left" },
    { name: "Area", align: "left" },
    { name: "City", align: "left" },
    { name: "Badge", align: "left" },
    { name: "Old Tutor", align: "left" },
    { name: "Old Tutor Salary", align: "left" },
    { name: "Old Tutor Status", align: "center" },
    { name: "Tutor Replace Date", align: "left" },
    { name: "Start Date", align: "left" },
    { name: "Start Time", align: "center" },
    { name: "End Time", align: "center" },
  ],

  rows: classes.map((classSession, index) => ({
    sno: (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {index + 1}
      </ArgonTypography>
    ),
    "Class Name": (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {classSession.student?.subjects?.join(", ") || "N/A"}
      </ArgonTypography>
    ),
    Mode: (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {classSession.classType || "N/A"}
      </ArgonTypography>
    ),
    // State: (
    //   <ArgonTypography variant="caption" color="text" fontWeight="medium">
    //     N/A
    //   </ArgonTypography>
    // ),
    // City: (
    //   <ArgonTypography variant="caption" color="text" fontWeight="medium">
    //     {classSession.parentId?.city || "N/A"}
    //   </ArgonTypography>
    // ),
    Area: (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {extractAddressPart(classSession.address, "Area")}
      </ArgonTypography>
    ),
    City: (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {extractAddressPart(classSession.address, "City")}
      </ArgonTypography>
    ),
    Badge: (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {classSession.type === "NORMAL" ? "Regular" : classSession.type}
      </ArgonTypography>
    ),
    "Old Tutor": (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {classSession.oldTutorDetails?.fullName || "N/A"}
      </ArgonTypography>
    ),
    "Old Tutor Salary": (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        ₹ {Math.round(classSession.oldTutorPerClassSalary || 0)}
      </ArgonTypography>
    ),
    "Old Tutor Status": (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {classSession.oldTutorSalaryStatus || "N/A"}
      </ArgonTypography>
    ),
    "Tutor Replace Date": (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {classSession.oldTutorReplacedAt
          ? new Date(classSession.oldTutorReplacedAt).toLocaleDateString()
          : "N/A"}
      </ArgonTypography>
    ),
    "Start Date": (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {classSession.createdAt ? new Date(classSession.createdAt).toLocaleDateString() : "N/A"}
      </ArgonTypography>
    ),
    "Start Time": (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {classSession.finalisedActiveSlot?.startTime || "N/A"}
      </ArgonTypography>
    ),
    "End Time": (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {classSession.finalisedActiveSlot?.endTime || "N/A"}
      </ArgonTypography>
    ),
  })),
});

export default parentsProfileTableData;
